//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {};
  },
  computed: {
    url() {
      return this.$route.query.url;
    },
  },
  methods: {},
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/gamePlay/index.vue